<convfact-investment-form [investment]="investment" [errors]="errors" [accounts]="accounts"
  [accountsAndTaxes]="accountsAndTaxes" [bankAccounts]="bankAccounts" [providers]="providers"
  (onSave)="saveData($event)"></convfact-investment-form>
